import React from "react";
import { Link } from "react-router-dom";
import { Clock, Users, ChefHat } from "lucide-react";

const FALLBACK_IMG = "/recipe-default.jpg";

export default function RecipeCard({ recipe, featured = false }) {
  const giClass =
    recipe.gi_level === "bas"
      ? "badge-gi-bas"
      : recipe.gi_level === "modere"
      ? "badge-gi-modere"
      : "badge-gi-eleve";

  return (
    <Link
      to={`/recettes/${recipe.slug}`}
      data-testid={`recipe-card-${recipe.slug}`}
      className={`recipe-card group block ${featured ? "" : ""}`}
    >
      <div className={`relative overflow-hidden bg-[hsl(var(--bg-subtle))] ${featured ? "aspect-[4/3]" : "aspect-[4/5]"}`}>
        <img
          src={recipe.image_url || "/recipe-default.jpg"}
          alt={recipe.title}
          className="recipe-card-img w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className={giClass} data-testid={`gi-badge-${recipe.slug}`}>
            IG {recipe.gi_level} · {recipe.glycemic_index}
          </span>
        </div>
      </div>
      <div className="pt-4">
        <p className="overline mb-1" data-testid={`recipe-category-${recipe.slug}`}>
          {recipe.category === "entree" ? "Entrée" : recipe.category === "plat" ? "Plat" : recipe.category === "dessert" ? "Dessert" : recipe.category}
          {recipe.country && recipe.country !== "France"
            ? ` · ${recipe.country}`
            : recipe.region
            ? ` · ${recipe.region}`
            : ""}
        </p>
        <h3 className={`font-serif tracking-tight leading-tight text-[hsl(var(--text-primary))] group-hover:text-[hsl(var(--brand-primary))] transition-colors ${featured ? "text-3xl" : "text-2xl"}`} data-testid={`recipe-title-${recipe.slug}`}>
          {recipe.title}
        </h3>
        {recipe.subtitle && (
          <p className="text-sm text-[hsl(var(--text-secondary))] mt-1.5 line-clamp-2">
            {recipe.subtitle}
          </p>
        )}
        <div className="mt-3 flex items-center gap-4 text-xs text-[hsl(var(--text-muted))]">
          <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" strokeWidth={1.5} /> {(recipe.prep_time_min || 0) + (recipe.cook_time_min || 0)} min</span>
          <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" strokeWidth={1.5} /> {recipe.serves} pers.</span>
          <span className="inline-flex items-center gap-1"><ChefHat className="w-3.5 h-3.5" strokeWidth={1.5} /> {recipe.difficulty}</span>
        </div>
      </div>
    </Link>
  );
}
